<template>
	<div class="vpay__dropdown" :class="{ 'vpay__dropdown--open' : open }" @click="onClickOption">
		<p class="vpay__dropdown-title" :class="{ 'vpay__dropdown-title--selected': selectedOptionTitleText }">{{ selectedOptionTitleText ? selectedOptionTitleText : placeholderText }}</p>
		<ion-icon class="vpay__dropdown-caret" name="arrow-dropdown"></ion-icon>
		<transition name="dropdown">
			<div v-show="open" class="vpay__dropdown-options">
				<slot :options="options" :selected="selectedOption"/>
			</div>
		</transition>
	</div>
</template>

<script>
	
	export default {
		
		props: {
			
			placeholderText: {
				type: String,
				default: "Select Option",
			},
			
			selectedOption: {
				type: Object,
				default() {
					return {};
				}
			},
			
			selectedOptionTitleText: {
				default: null,
			},
			
			options: {
				type: Array,
				default() {
					return [];
				}
			},
			
		},
		
		methods: {
			onClickOption() {
				this.open = !this.open;
			}
		},
		
		data() {
			return {
				open: false,
			}
		}
		
	}
	
</script>

<style lang="scss" scoped>
	
	@import "./style.scss";
	
</style>